// extracted by mini-css-extract-plugin
module.exports = {"container":"Table-module__container___3zBcj"};